import { FC, ReactNode, useState } from 'react';
import AppointmentsContext from './AppointmentsContext';

interface AppointmentsContextProviderProps {
  children?: ReactNode;
}

const AppointmentsContextProvider: FC<AppointmentsContextProviderProps> = ({
  children,
}) => {
  const [date, setDate] = useState<Date | null>(null);

  return (
    <AppointmentsContext.Provider
      value={{
        date,
        setFilter: (date) => {
          setDate(date);
        },
      }}
    >
      {children}
    </AppointmentsContext.Provider>
  );
};

export default AppointmentsContextProvider;
